import React from 'react';
import { useApp } from '../../context/AppContext';

export default function WorldBar() {
  const { activeWorld, setActiveWorld } = useApp();
  return (
    <div className="world-bar">
      <button className={`wtab biz ${activeWorld === 'biz' ? 'active' : ''}`} onClick={() => setActiveWorld('biz')}>
        🏢 Business
      </button>
      <button className={`wtab con ${activeWorld === 'con' ? 'active' : ''}`} onClick={() => setActiveWorld('con')}>
        🛍 Consumer
      </button>
      <div className="world-fill" />
      <button className={`wtab set ${activeWorld === 'set' ? 'active' : ''}`} onClick={() => setActiveWorld('set')}>
        ⚙️ Settings
      </button>
    </div>
  );
}
